export enum PamDecisionAction {
  APPROVE = 'approve',
  DENY = 'deny',
  UNLOCK = 'unlock',
}

export enum PamActionStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  ERROR = 'error',
}

export enum PamAccountAction {
  REACTIVATE = 'reactivate',
  DEACTIVATE = 'deactivate',
}

// Error codes the reactivate/deactivate endpoints return in `message`.
export enum PamAccountStatusErrorCode {
  PLAYER_ALREADY_DEACTIVATED = 'player_already_deactivated',
  PLAYER_NOT_DEACTIVATED = 'player_not_deactivated',
  CLERK_USER_MISSING = 'clerk_user_missing',
  REASON_REQUIRED = 'reason_required',
}
